import acintyo from "../../assets/images/Acintyo_5_11zon.webp";
import da from "../../assets/images/DA_7_11zon.webp";
import enorvision from "../../assets/images/Enorvision_1_11zon.webp";
import godsclub from "../../assets/images/Gods Club_6_11zon.webp";
import hbf from "../../assets/images/HBF_11zon.webp";
import indusExpert from "../../assets/images/Indus Expert_2_11zon.webp";
import taiiki from "../../assets/images/Taiiki_4_11zon.webp";
import relationai from "../../assets/images/Relation_AI.png";
import { Button } from "../ui/Button";

  const Partners = () => {
  const partners = [
    { name: "Acintyo", logo: acintyo },
    { name: "Derma Arts", logo: da },
    { name: "Enorvision", logo: enorvision },
    { name: "Gods Club", logo: godsclub },
    { name: "HBF Direct Ltd", logo: hbf },
    { name: "Indus Experts", logo: indusExpert }, 
    { name: "Taiiki Media", logo: taiiki },
    { name: "Relations AI", logo: relationai }
  ];

  // Duplicate partners for seamless infinite scroll
  const duplicatedPartners = [...partners, ...partners];

  return (
    <section className="py-16 px-6  bg-white text-textPrimary">
      <div className="max-w-7xl  mx-auto">
        
        {/* Heading */}
        <div className="text-center mb-12">
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-white mb-4">
            Partners & Sponsors
          </h2>
          <p className="text-textMuted max-w-2xl mx-auto text-base sm:text-lg">
            Meet our esteemed partners who make this event possible
          </p>
        </div>

        {/* CSS Infinite Scroll Container */}
        <div className="relative overflow-hidden">
          {/* Gradient Overlays */}
          <div className="absolute left-0 top-0 bottom-0 w-32 bg-gradient-to-r from-primary to-transparent z-10" />
          <div className="absolute right-0 top-0 bottom-0 w-32 bg-gradient-to-l from-primary to-transparent z-10" />
          
          {/* Infinite Scroll Animation */}
          <div className="flex">
            {/* First Set - Moving Left */}
            <div className="flex animate-infinite-scroll bg-white gap-8 py-6">
              {duplicatedPartners.map((partner, index) => (
                <div
                  key={`set1-${index}`}
                  className="
                    flex-shrink-0
                    w-48 md:w-56 h-32 md:h-36
                    rounded-xl
                    bg-tertiary/50 backdrop-blur-sm
                    border border-borderLight/30
                    shadow-card
                    flex items-center justify-center
                    hover:bg-secondary/40
                    hover:shadow-xl
                    transition-all duration-300
                    p-4 bg-white
                  "
                >
                  <img 
                    src={partner.logo} 
                    alt={`${partner.name} logo`}
                    className="max-h-20 md:max-h-24 bg-white max-w-full object-contain"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
            
            {/* Second Set - Duplicate for seamless loop */}
            <div className="flex animate-infinite-scroll gap-8 py-6" aria-hidden="true">
              {duplicatedPartners.map((partner, index) => (
                <div
                  key={`set2-${index}`}
                  className="
                    flex-shrink-0
                    w-48 md:w-56 h-32 md:h-36
                    rounded-xl
                    bg-tertiary/50 backdrop-blur-sm
                    border border-borderLight/30
                    shadow-card
                    flex items-center justify-center
                    p-4
                  "
                >
                  <img 
                    src={partner.logo} 
                    alt=""
                    className="max-h-20 md:max-h-24 max-w-full object-contain"
                    loading="lazy"
                  />
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Add CSS Animation */}
        <style>{`
          @keyframes infinite-scroll {
            from {
              transform: translateX(0);
            }
            to {
              transform: translateX(-50%);
            }
          }
          
          .animate-infinite-scroll {
            animation: infinite-scroll 30s linear infinite;
          }
          
          .animate-infinite-scroll:hover {
            animation-play-state: paused;
          }
        `}</style>

       

        {/* CTA */}
        <div className="text-center mt-12">
          <a 
            href="/investor"
            className="
              inline-block
              px-8 py-3 rounded-lg
              bg-accent text-white font-medium
              hover:bg-accent/80
              transition-colors duration-300
            "
          >
<Button size="md">
  Become a Partner
  
          </Button>
          </a>
        </div>

      </div>
    </section>
  );
};

export default Partners;